import { Field, useFormikContext } from 'formik';
import React from 'react';
import { useDashboardFeatureFlags } from '@components';
import { Checkbox, Fieldset, Subsection } from '@fourthwall/components';
export const Memberships = () => {
    const { values } = useFormikContext();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    if (!dashboardFeatureFlags.memberships.enabled)
        return null;
    return (React.createElement(Subsection, { title: "Memberships" },
        React.createElement(Fieldset, null,
            React.createElement(Fieldset.Row, null,
                React.createElement(Fieldset.Item, null,
                    React.createElement(Field, { component: Checkbox, name: 'newMembers', label: "New members", description: "Notify me when new members join" }))),
            React.createElement(Fieldset.Row, null,
                React.createElement(Fieldset.Item, null,
                    React.createElement(Field, { component: Checkbox, name: 'newPostComments', label: "New post comments", description: "Notify me about new comments under my posts" }))),
            values.newPostComments && (React.createElement(Fieldset.Row, { inner: true },
                React.createElement(Fieldset.Item, null,
                    React.createElement(Field, { component: Checkbox, name: 'newPostCommentsReply', label: "Only replies to my comments" })))),
            dashboardFeatureFlags.membershipsMessages.enabled && (React.createElement(React.Fragment, null,
                React.createElement(Fieldset.Row, null,
                    React.createElement(Fieldset.Item, null,
                        React.createElement(Field, { component: Checkbox, name: 'newDirectMessage', label: "New messages from members", description: "Notify me when a member sends me a private message" }))),
                values.newDirectMessage && (React.createElement(Fieldset.Row, { inner: true },
                    React.createElement(Fieldset.Item, null,
                        React.createElement(Field, { component: Checkbox, name: 'newDirectMessageWithTip', label: "Only notify me if the message includes a tip" })))),
                React.createElement(Fieldset.Row, null,
                    React.createElement(Fieldset.Item, null,
                        React.createElement(Field, { component: Checkbox, name: 'messageUnlocks', label: "Message unlocks", description: "Notify me when a message is unlocked" }))))))));
};
